import React from "react";

import LocationSubscriptionSSE from "./LocationSubscriptionSSE";

function CommonSSE() {
  return (
    <>
      <LocationSubscriptionSSE />
    </>
  );
}

export default CommonSSE;
